import { render, staticRenderFns } from "./LandingWidget.vue?vue&type=template&id=4e5410a4&"
import script from "./LandingWidget.vue?vue&type=script&lang=ts&"
export * from "./LandingWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports